import Bloodhound from "bloodhound-js";

$(function(){
    var schools = JSON.parse(document.getElementById('school-data').textContent);
    var schoolsEngine = new Bloodhound({
        // schools is a global var generated in booklists/school_list.html by django
        local: Object.keys(schools),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        datumTokenizer: Bloodhound.tokenizers.whitespace
    });
    schoolsEngine.initialize();

    $('#school-search').autocomplete({
        minChars: 2,
        lookup: function(query, done){
            schoolsEngine.search(query, function(datums){
                var suggestions = $.map(datums, function(item) {
                    return {
                        value: item,
                        data: {
                            'url': schools[item]
                        },
                    };
                });
                done({suggestions: suggestions});
            });
        },
        onSelect: function (suggestion){
            // Clear the form value, otherwise this onSelect event fires
            // without any action on the user's part if they reload the page and try to
            // search again.
            $('#school-search').val('');
            window.location.href = suggestion.data.url;
        }
    });
});
